import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';
import { reducer as toastr } from 'react-redux-toastr'

import auth from './auth';
import config from './config';
import development from './development';
import heartbeat from './heartbeat';
import modals from './modals';
import property from './property';
import socket from './socket';
import user from './user';

export default combineReducers({
  auth,
  config,
  development,
  heartbeat,
  modals,
  property,
  router,
  socket,
  toastr,
  user,
});



// WEBPACK FOOTER //
// ./src/redux/index.js